import React from 'react';

const UserModal = ({ show, user, onClose, onSave, selectedRole, onRoleChange }) => {
  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-md w-full p-6">
        <h2 className="text-2xl font-bold text-white mb-6">
          Edit User Role
        </h2>

        <form onSubmit={handleSubmit}>
          {/* User Info */}
          <div className="mb-4 p-4 bg-gray-700 rounded">
            <div className="mb-2">
              <span className="text-gray-400 text-sm">Username:</span>
              <p className="text-white font-medium">{user?.username}</p>
            </div>
            <div className="mb-2">
              <span className="text-gray-400 text-sm">Email:</span>
              <p className="text-white">{user?.email}</p>
            </div>
            <div>
              <span className="text-gray-400 text-sm">Current Role:</span>
              <p className="text-white capitalize">{user?.role}</p>
            </div>
          </div>

          {/* Role Selection */}
          <div className="mb-6">
            <label className="block text-white mb-2 font-medium">
              New Role
            </label>
            <select
              value={selectedRole}
              onChange={(e) => onRoleChange(e.target.value)}
              className="w-full p-3 bg-gray-700 text-white rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
              required
            >
              <option value="viewer">Viewer</option>
              <option value="artist">Artist</option>
              <option value="admin">Admin</option>
            </select>

            {/* Role Descriptions */}
            <div className="mt-3 p-3 bg-gray-900 rounded text-sm">
              {selectedRole === 'admin' && (
                <p className="text-red-300">
                  <strong>Admin:</strong> Full access to manage videos, artists, users, and site content.
                </p>
              )}
              {selectedRole === 'artist' && (
                <p className="text-purple-300">
                  <strong>Artist:</strong> Can be tagged in videos and view their profile page.
                </p>
              )}
              {selectedRole === 'viewer' && (
                <p className="text-gray-300">
                  <strong>Viewer:</strong> Can browse and purchase videos.
                </p>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserModal;
